import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from './views/Home'
import Gallery from './views/Gallery'
import Properties from './views/Properties'
import PropertyNilaveli from './views/PropertyNilaveli'
import PropertyColombo from './views/PropertyColombo'
import PropertyTurle from './views/PropertyTurtle'
import About from './views/AboutUs'
import Inquiry from './views/Inquiry'
import Excursions from './views/Excursions'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/gallery', name: 'Gallery', component: Gallery },
  { path: '/properties', name: 'Properties', component: Properties },
  { path: '/about-us', name: 'About', component: About },
  { path: '/inquiry', name: 'Inquiry', component: Inquiry },
  { path: '/excursions', name: 'Excursions', component: Excursions },
  { path: '/casamia-nilaveli', name: 'PropertyNilaveli', component: PropertyNilaveli },
  { path: '/casamia-colombo', name: 'PropertyColombo', component: PropertyColombo },
  { path: '/turtle-nest', name: 'PropertyTurtle', component: PropertyTurle },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE,
  routes,
  scrollBehavior (to) {
    if (to.hash) {
      if (to.name === 'Excursions') {
        switch (to.hash) {
          case '#nilaveli':
            return { x: 0, y: 825 }
          case '#colombo':
            return { x: 0, y: 1325 }
          case '#rekawa':
            return { x: 0, y: 1825 }
          default:
            return { x: 0, y: 0 }
        }
      } else if (to.name === 'PropertyNilaveli' && to.hash === '#special-packages') {
        return { x: 0, y: 7200 }
      } else if (to.name === 'PropertyColombo' && to.hash === '#special-packages') {
        return { x: 0, y: 3200 }
      }
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
